import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { GeoipCity } from './geoip-city.model';
import { GeoipCountry } from './geoip-country.model';
import { GeoipLocation } from './geoip-location.model';

export const LOCATION_INFO_SCHEMA = Object.freeze({
  CITY: GeoipCity,
  COUNTRY: GeoipCountry,
  LOCATION: GeoipLocation,
});
const RECORD = generateSchema(LOCATION_INFO_SCHEMA);
const KEYS: any = generateKeys(LOCATION_INFO_SCHEMA);

export class LocationInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CITY,
        value: new GeoipCity(this.city),
      },
      {
        key: KEYS.COUNTRY,
        value: new GeoipCountry(this.country),
      },
      {
        key: KEYS.LOCATION,
        value: new GeoipLocation(this.location),
      },
    ]);

    return selfModel as LocationInfo;
  }

  get city(): GeoipCity {
    return this.get(KEYS.CITY);
  }

  get country(): GeoipCountry {
    return this.get(KEYS.COUNTRY);
  }

  get location(): GeoipLocation {
    return this.get(KEYS.LOCATION);
  }
}
